import { type State } from 'app/common/ui-components/filter'

import { flags as org } from 'app/components/common/reports/filters/org'
import { flags as productionType } from 'app/components/common/reports/filters/productionType'
import { flags as group } from './group'
import { flags as groupComplexesSpecial } from './groupComplexesSpecial'


const activity = (state: State) => {
  return (
    org.singleOrgSelected(state)
    && (
      group.byPurchasesSelected(state)
      || group.byItemsAndComplexesSelected(state)
      || group.byItemsAndComplexesAndCostSelected(state)
    ) && productionType.onlyDishesSelected(state)
  ) || (
    org.multipleOrgsSelected(state)
    && groupComplexesSpecial.byNonSpecialSelected(state)
    && productionType.onlyDishesSelected(state)
  )
}

export default activity
